import styled from 'styled-components';
import tw from 'twin.macro';

import { getInputFieldLabelColor } from '@nw/shared/utils';

import { colors as Colors } from '../../themes/Colors';

export const LabelContainer = styled.span`
  display: flex;
  flex-wrap: wrap;
  font-family: HKGrotesk;
  max-width: 100%;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: ${(props) =>
    getInputFieldLabelColor({
      isValid: props.status,
      inputFieldStyles: props.inputFieldStyles,
    })};
  @media (max-width: 768px) {
    max-width: 100%;
  }
  ${(props) => props.css}
`;

export const OtpInputContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  margin-bottom: 8px;
  .otp-input-container {
    min-width: 38px;
    max-width: 48px;
    flex: 1;
    border: 1px solid ${Colors.geyser};
    border-radius: 8px;
    margin-right: 14px !important;
    color: ${Colors.lightCement};
    font-size: 16px;
    &:last-child {
      margin-right: 0px !important;
    }
    @media (max-width: 440px) {
      width: 38px;
    }
  }
  .otp-input-focus-style {
    border: 1px solid ${Colors.cerulean} !important;
    outline: none;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.08);
  }
  .otp-input-error-style {
    border: 1px solid ${Colors.lipstick};
    color: ${Colors.lipstick};
  }
  @supports (aspect-ratio: 1 / 1) {
    input {
      aspect-ratio: 1 / 1;
    }
  }
  @supports not (aspect-ratio: 1 / 1) {
    input {
      min-height: 38px;
      max-height: 48px;
    }
  }

  input {
    ${tw`font-inter text-center rounded-8px border-default bg-base-white box-border border-blue-gray-300`};
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.08);
    ${({ isValid }) => (isValid ? tw`` : tw`border-red-600`)}
    /* Remove mobile tap highlight to prevent persistent focus state */
    -webkit-tap-highlight-color: transparent;
    /* Focus styling is controlled by component classes, not pseudo-classes */
  }

  ${(props) => props.css}
`;
export const OTPFieldLabel = styled(LabelContainer)`
  color: ${Colors.lightCement};
  font-size: 14px;
  margin-bottom: 12px;
  ${(props) => props.css}
`;

export const ErrorMessage = styled('p')`
  font-weight: 500;
  min-height: 16px;
  font-size: 12px;
  margin-top: 4px;
  color: ${Colors.lipstick};
  ${(props) => props.css}
`;
